<div *ngIf="!show && (loader.isLoading$ | async)" class="spinner-overlay">
  <div class="spinner-col">
    <div [classList]="['loader', size].join(' ')"></div>
    <div *ngIf="loader.message$ | async as msg" class="loader-message">{{ msg }}</div>
  </div>
</div>
<div *ngIf="show" [classList]="['loader', size].join(' ')"></div>
